module.exports = {
          srcSet: __webpack_public_path__ + "af405363fb6cc1cf8c1f0fac42013432-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "af405363fb6cc1cf8c1f0fac42013432-60.png",width: 60,height: 4}],
          src: __webpack_public_path__ + "af405363fb6cc1cf8c1f0fac42013432-60.png",
          toString:function(){return __webpack_public_path__ + "af405363fb6cc1cf8c1f0fac42013432-60.png"},
          
          width: 60,
          height: 4
        }